// extracted by mini-css-extract-plugin
export var notificationsWrapper = "notifications-wrapper__ww_2";